import script from "./CommandButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./CommandButton.vue?vue&type=script&setup=true&lang=ts"

import "./CommandButton.vue?vue&type=style&index=0&id=a6498da0&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a6498da0"]])

export default __exports__